import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import ClearIcon from '@material-ui/icons/Clear';
import { RootState } from '../../../models/RootState';
import {
  getCurrencyTypeFromToken,
  FatchLiveCasinoGames,
  setSearchGame,
  handleSearchGame,
} from '../../../store';
import { GapGame } from '../../../models/dc/DcGame';
import inplay from '../../../assets/images/common/icons/Polygon.svg';
import { IonRow, IonCol } from '@ionic/react';
import RightSideNav1 from '../../../views/CommissionRules/RightSideNav/RightSideNav1';
import CompetitionsMenu from '../../../components/ExchCompetitionsMenu/ExchCompetitionsMenu';
import casinobg from '../../../assets/images/common/casinobg.png';
import './CasinoNew.scss';

type StoreProps = {
  loggedIn: boolean;
  loggedInUserStatus: any;
  liveCasinoGames: GapGame[];
  FatchLiveCasinoGames: (type: string) => void;
  setSearchGame: Function;
  searchGame: string;
  handleSearchGame: () => void;
};

const SlotGamesPage: React.FC<StoreProps> = (props) => {
  const {
    loggedIn,
    loggedInUserStatus,
    liveCasinoGames,
    FatchLiveCasinoGames,
    setSearchGame,
    searchGame,
    handleSearchGame,
  } = props;
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [search, setSearch] = useState<string>('');
  const [showDialog, setShowDialog] = useState<boolean>(false);

  const history = useHistory();

  const setDialogShow = (show: boolean) => {
    setShowDialog(show);
  };

  useEffect(() => {
    FatchLiveCasinoGames('virtual');
  }, []);

  const getGameUrl = async (
    gameId: string,
    gameName: string,
    gameCode: string,
    provider: string,
    subProvider: string
  ) => {
    if (loggedIn) {
      console.log(loggedInUserStatus);
      if (loggedInUserStatus === 0 || loggedInUserStatus === 3) {
        history.push(`/home`);
      }
      if (provider === 'Indian Casino') {
        history.push(`/casino/indian/${gameCode}`);
      } else {
        history.push(
          `/gap_casino/game/${gameName
            .toLowerCase()
            .replace(/\s+/g, '-')}-${btoa(gameId.toString())}-${btoa(
            gameCode
          )}-${btoa(provider)}-${btoa(subProvider)}`
        );
      }
    } else {
      setDialogShow(true);
    }
  };

  let virtualGames = liveCasinoGames.filter(
    (g) => g.providerName?.toLowerCase() === 'vsbr'
  );

  useEffect(() => {
    document.getElementsByClassName('router-ctn')[0].scrollIntoView();
  }, []);
  return (
    <div className="dc-page-bg">
      <div className="dc-ctn">
        <IonRow>
          <IonCol sizeMd="1.8" sizeLg="1.8" className="web-view">
            <div className="compt-menu-section">
              <div className="sticky-col">
                <CompetitionsMenu loggedIn={true} />
              </div>
            </div>
          </IonCol>
          <IonCol sizeXs="12" sizeSm="12" sizeMd="8" sizeLg="8">
            <div className="title-card mob-view">
              <div className="search-bar-component">
                <input
                  className="search-bar"
                  placeholder="search games"
                  name="searchText"
                  type="text"
                  value={searchGame}
                  onChange={(e: any) => setSearchGame(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleSearchGame()}
                />

                <div
                  className={'search-icon'}
                  onClick={() => handleSearchGame()}
                ></div>
              </div>
            </div>
            <div className="card mt-slots">
              <div className="carw">
                <div className="arrow arrow-right w-150">
                  <span className="color-active">Virtual</span>{' '}
                  <span className="web-view">Games</span>
                </div>
              </div>
              {virtualGames && virtualGames.length > 0 ? (
                <>
                  <IonRow className="dc-games-ctn">
                    {virtualGames
                      .filter((item) =>
                        item.gameName
                          .toLowerCase()
                          .includes(search.toLocaleLowerCase())
                      )
                      .map((g, i) => (
                        <IonCol
                          sizeXs="4"
                          sizeSm="4"
                          sizeMd="3"
                          sizeLg="3"
                          key={g.gameName}
                        >
                          <div className="container1">
                            <img
                              src={g.urlThumb ? g.urlThumb : ''}
                              alt={g.gameName}
                              className="dc-img"
                            />
                            <div className="overlay1">
                              <div className="text1">
                                <div
                                  className="custom-btn"
                                  onClick={() =>
                                    getGameUrl(
                                      g.gameId,
                                      g.gameName,
                                      g.gameCode,
                                      g.providerName,
                                      g.subProviderName
                                    )
                                  }
                                >
                                  <img src={inplay} alt="inplay" />
                                  <div> </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </IonCol>
                      ))}
                  </IonRow>
                </>
              ) : (
                <div className="no-data">No games found</div>
              )}
            </div>
          </IonCol>

          <IonCol sizeMd="2" sizeLg="2" className="web-view">
            <div className="compt-menu-section">
              <div className="search-bar-component">
                <input
                  className="search-bar"
                  placeholder="search games"
                  name="searchText"
                  type="text"
                  value={searchGame}
                  onChange={(e: any) => setSearchGame(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleSearchGame()}
                />

                <div
                  className={'search-icon'}
                  onClick={() => handleSearchGame()}
                ></div>
              </div>
              <RightSideNav1 />
            </div>
          </IonCol>
        </IonRow>
      </div>

      <Dialog
        open={showDialog}
        onClose={() => setDialogShow(false)}
        aria-labelledby="form-dialog-title"
        className="dialog-div1"
      >
        <div className="dialog-div-body">
          <div className="go-corner" onClick={() => history.goBack()}>
            <div className="go-arrow">
              <ClearIcon />
            </div>
          </div>
          <div className="dialog-body">
            <div className="dialog-title">Notice</div>

            <p className="dialog-ex">You have to be logged in to play</p>
          </div>

          <div className="dialog-continue" onClick={() => setDialogShow(false)}>
            <div className="custom-btn btn">OK</div>
          </div>
        </div>
      </Dialog>
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="form-dialog-title"
        className="dialog-div"
      >
        <div className="dialog-div-body">
          <div className="go-corner" onClick={() => setOpenDialog(false)}>
            <div className="go-arrow">
              <ClearIcon />
            </div>
          </div>

          {getCurrencyTypeFromToken() === 0 ? (
            <div className="dialog-body">
              {/* 1 Live casino point is equal to 100 normal points
              <div className="dialog-ex">
                {' '}
                Ex: 100 casino points = 10000 normal points
              </div> */}
              <img src={casinobg} />

              <p className="dialog-ex">
                Maximum Bet limit is 5000 casino points
              </p>
            </div>
          ) : null}

          {getCurrencyTypeFromToken() === 1 ? (
            <>
              {' '}
              <div className="dialog-body">
                <img src={casinobg} />
                <div className="dialog-ex">
                  {' '}
                  Maximum Bet Limit For All Games is 5000
                </div>
              </div>
            </>
          ) : null}

          <div className="dialog-continue" onClick={() => setOpenDialog(false)}>
            <div className="custom-btn">Continue</div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  let status = 0;
  if (state.auth.loggedIn) {
    status = JSON.parse(
      window.atob(sessionStorage.getItem('jwt_token').split('.')[1])
    ).status;
  }
  return {
    loggedIn: state.auth.loggedIn,
    loggedInUserStatus: status,
    liveCasinoGames: state.indianCasino.liveCasinoGames,
    searchGame: state.indianCasino.searchGame,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    FatchLiveCasinoGames: (type: string) =>
      dispatch(FatchLiveCasinoGames(type)),
    setSearchGame: (data: string) => dispatch(setSearchGame(data)),
    handleSearchGame: () => dispatch(handleSearchGame()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SlotGamesPage);
